import { atomWithStorage } from 'jotai/utils';
import { z } from 'zod';
import { createSafeStorage } from '../utils/storage-utils';

export const AppSettingsSchema = z.object({
  themeMode: z.enum(['system', 'light', 'dark'])
});

export type AppSettings = z.infer<typeof AppSettingsSchema>;

const defaultSettings: AppSettings = {
  themeMode: 'light'
};

export const appSettingsAtom = atomWithStorage<AppSettings>(
  'appSettings',
  defaultSettings,
  createSafeStorage(AppSettingsSchema, defaultSettings)
);
